module.exports = __webpack_public_path__ + "media/images/icons/outlined/sound-0a79f096142d302931bb25d171a9f5bd.svg";